import * as React from 'react'

import { observer } from 'mobx-react'

import FormRow from 'modules/core/components/FormRow'
import EmployeeSelectorInput from 'modules/core/components/Inputs/EmployeeSelector'
import i18n from 'modules/core/lib/i18n'

import type { ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import type Employee from 'modules/employees/store/models/Employee'
import type LeaveForm from 'modules/timeoff/lib/LeaveForm'

interface Props {
  form: LeaveForm
  showEmployeeSelector: boolean
  onSelectEmployee?: (Ids: number[] | (number | null | undefined)) => void
  selectedEmployeeIds?: number[]
  selectableEmployees: Employee[]
  isMedicalLeave: boolean
  contractVersions: ContractVersions
}

const EmployeeSelector = ({
  form,
  showEmployeeSelector,
  onSelectEmployee,
  selectedEmployeeIds,
  selectableEmployees,
  isMedicalLeave,
  contractVersions,
}: Props) => {
  if (!showEmployeeSelector) return null

  if (isMedicalLeave) {
    return (
      <FormRow>
        <EmployeeSelectorInput
          attachment="top center"
          employees={selectableEmployees}
          field={form.get('employee_id')}
          label={i18n.t('common.employee')}
          multiFilters
          contractVersions={contractVersions}
        />
      </FormRow>
    )
  }

  if (!onSelectEmployee || !selectedEmployeeIds) return null

  return (
    <FormRow>
      <EmployeeSelectorInput
        hasSubmitButton
        isMultiSelect
        attachment="top center"
        employees={selectableEmployees}
        field={form.get('employee_id')}
        filterProps={{
          showFilterByTeam: true,
        }}
        label={i18n.t('common.employee')}
        onSelectEmployee={onSelectEmployee}
        selectedEmployeeIds={selectedEmployeeIds}
        multiFilters
        contractVersions={contractVersions}
      />
    </FormRow>
  )
}

export default observer(EmployeeSelector)
